<template>
  <div class="box3">
    <div class="title">
      <p>架构师前景一片光明</p>
    </div>
    <div class="subTitle">
      架构师薪酬居高不下，远超普通开发<br />30k以上人群占比高达52.7%
    </div>
    <!-- <div class="tit">
      01 薪资远超普通开发
      <p>薪资30K以上人群超过60%、20K以上超过86%</p>
    </div> -->

    <div class="content-box">
      <swiper :options="swiperOption" ref="mySwiper" class="swiperitems">
        <swiper-slide
          class="swiperwrap"
          v-for="(item, index) in list"
          :key="index"
        >
          <img
            :src="
              require(`../../assets/architect/box3/${
                index + 1
              }.png`)
            "
            alt
          />
        </swiper-slide>
      </swiper>

      <div class="swiper-pagination-box3"></div>
    </div>
    <CourseVideo :src="src" :flag="flag" @close="close" specialStyle="1"></CourseVideo>
    <div class="btn" @click="childMethod">了解架构师就业前景</div>
  </div>
</template>

<script>
import pageTitle from "../../components/common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import CourseVideo from "../../components/common/courseVideo.vue";
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
    CourseVideo,
  },
  mounted() {},
  data() {
    // let that = this;
    return {
      cur: 0,
      list: [{}, {}],
      flag: false, src: "",
      swiperOption: {
        loop: true, // 循环模式选项
        slidesPerView: "auto",
        spaceBetween: 16,
        // slidesOffsetBefore: 16,
        // slidesOffsetAfter: 16,
        pagination: {
          el: ".swiper-pagination-box3",
        },
      },
    };
  },
  methods: {
    close() {
      this.src = "";
      this.flag = false;
    },
    childMethod() {
      this.$parent.itcastClick();
    }
  },
};
</script>

<style lang="less" scoped>
.box3 {
  padding: 80px 0;
  padding-top: 70px;
  width: 100%;
  background: linear-gradient(180deg, #ffffff 0%, #ebf3ff 100%);
  overflow: hidden;
  .btn{
    width: 400px;
    height: 78px;
    font-size: 34px;
    color: #fff;
    text-align: center;
    line-height: 78px;
    border-radius: 14px;
    background: #ff5627;
    margin: 30px auto 0;
  }
  .title {
    font-family: PingFangSC-Semibold;
    font-size: 40px;
    text-align: center;
    font-weight: bold;

    line-height: 62px;
    letter-spacing: 0px;
    color: #24375c;
  }
  .subTitle {
    font-family: PingFangSC-Medium;
    font-size: 32px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 48px;
    letter-spacing: 0px;
    color: #24375c;
    text-align: center;
    margin: 50px 0 20px;
  }
  .tit {
    margin-top: 50px;
    margin-bottom: 48px;
    font-family: PingFangSC-Medium;
    font-size: 34px;
    text-align: center;
    font-weight: bold;
    font-stretch: normal;
    line-height: 36px;
    letter-spacing: 0px;
    color: #24375c;
    p {
      margin-top: 16px;
      font-family: PingFang SC;
      font-size: 24px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 40px;
      letter-spacing: 0px;
      color: #24375c;
    }
  }

  .swiper-slide {
    // width: 690px;
    // height: 706px;
    // background-color: #ffffff;
    // box-shadow: 0px 6px 24px 0px #dbefff;
    // border-radius: 20px;
    text-align: center;
    img {
      width: 690px;
      height: 706px;
      background-color: #ffffff;
      box-shadow: 0px 6px 24px 0px #dbefff;
      margin: 30px 0;
      border-radius: 20px;
    }
    box-sizing: border-box;
  }

  .content-box {
    position: relative;
    padding-bottom: 20px;
  }

  .swiper-pagination-box3 {
    display: flex;
    align-items: center;
    position: absolute;
    left: 50%;
    margin-top: 2px;
    transform: translate(-50%, 0px);
    height: 6px;
    // background: rgba(46, 165, 252, 0.16);
    border-radius: 3px;
    background-color: #b6ddff;
  }

  /deep/ .swiper-pagination-bullet {
    width: 20px;
    height: 6px;
    background-color: #b6ddff;
    border-radius: 3px;
    opacity: 1;
  }

  /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 20px;
    height: 6px;
    background: #2ea5fc;
    border-radius: 3px;
  }
  .videoBox {
   box-shadow: 0px 6px 24px 0px #dbefff;
   margin: 43px auto 0;
      width: 690px;
      height: 389px;
    img {
      width: 690px;
      height: 389px;
    }
  }
}
</style>
